export default "__VITE_ASSET__COAIY1xJ__"